import './Brands.css';

export default function Brands({ details }) {
  return (
    <section id='section-brand' className='section-brands'>
      <h1 className='section-heading'>BRANDS</h1>
      <div className='container-brands'>
        {details.map((item) => (
          <div key={item.id} className='container-brand-details'>
            <div className='container-brand-logo'>
              <img
                className='brand-logo'
                src={item.logo.src}
                alt={item.logo.altText}
              />
            </div>

            <img
              className='prachurya-image'
              src={item.prachurya.src}
              alt={item.prachurya.altText}
            />
            <p className='brand-description'>{item.details}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
